var levelOfAWSUsage = {
	"Level of AWS usage": "AWS 사용 수준",
	"Do not use AWS today": "현재 AWS를 사용하고 있지 않음",
	"Evaluating/experimenting with AWS": "AWS와 함께 평가/실험 중",
	"Run dev/test workloads on AWS": "AWS에서 개발/테스트 워크로드 실행",
	"Run a production workload on AWS": "AWS에서 단일 프로덕션 워크로드 실행",
	"Run multiple production workloads on AWS": "AWS에서 다중 프로덕션 워크로드 실행"
};

export { levelOfAWSUsage as default };
